import React, { ReactElement } from 'react';
import { Body, Headline } from '../../../components';

export default function MonthsToMinutesCallout(): ReactElement {
  return (
    <section className="flex justify-center p-4 pt-30">
      <div className="w-240 max-w-240">
        <div className="relative flex justify-center">
          <Headline
            level="1"
            color="blue"
            className="relative z-10 text-center">
            Speed up your accessibility
            <br />
            workflow from months to minutes
          </Headline>

          <svg
            width="307"
            height="58"
            viewBox="0 0 307 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute right-4 bottom-0 mt-16 hidden md:block">
            <path d="M0 57.5L4.5 5.5L307 0L299.5 57.5H0Z" fill="#FEDB63" />
          </svg>
        </div>
        <Body className="mx-auto my-10 max-w-183.5 text-center" color="blue">
          More than 40,000 designers, developers, product managers, and
          accessibility experts from over 28,000 companies use Stark’s suite of
          integrated accessibility tools in their daily product development
          cycle. Join them today!
        </Body>
      </div>
    </section>
  );
}
